/**
 * AutopilotPageShell — wspólny shell (scroll + header back/title/actions)
 * dla wszystkich stron autopilota i firm-assets.
 */
import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export interface AutopilotPageShellProps {
  title: string;
  subtitle?: React.ReactNode;
  backHref?: string;
  backLabel?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  /** Default container max-w. Override np. 'max-w-[1600px]' dla pipeline'u. */
  maxWidthClass?: string;
}

export function AutopilotPageShell({
  title,
  subtitle,
  backHref = "/admin/autopilot",
  backLabel = "Autopilot Ads",
  actions,
  children,
  maxWidthClass = "max-w-6xl",
}: AutopilotPageShellProps) {
  return (
    <div className="h-full overflow-y-auto">
      <div className={`container mx-auto p-6 space-y-4 ${maxWidthClass}`}>
        <div className="flex items-start justify-between flex-wrap gap-3 mb-2">
          <div className="flex-1 min-w-0">
            <Link href={backHref}>
              <Button
                variant="ghost"
                size="sm"
                className="text-white/60 hover:text-white -ml-2 mb-1"
              >
                <ArrowLeft className="h-4 w-4 mr-1" /> {backLabel}
              </Button>
            </Link>
            <h1 className="text-2xl font-bold">{title}</h1>
            {subtitle && <div className="text-sm text-muted-foreground mt-1">{subtitle}</div>}
          </div>
          {actions && <div className="flex gap-2 flex-shrink-0">{actions}</div>}
        </div>
        {children}
      </div>
    </div>
  );
}

export const AutopilotPageHeader = AutopilotPageShell;
